import { Estado } from "./estado.model";
import { BaseModel } from "./base-model.model";
import { HistoricoEstado } from "./historico-estado.model";

export class AcompanhamentoDocumentoDepr extends BaseModel {
  tipo: TipoAcompanhamentoDocumentoDepr;
  anoCompetencia: number;
  periodo: PeriodoAcompanhamentoDocumentoDepr;
  estado: Estado;
  dataEnvio: Date;
  cnpjAgenteFinanceiro: string;
  historicos: HistoricoEstado[];
  nomeAnexo?: string;
  motivoEstado: string;
  identificadorArquivo: number;
}

export enum TipoAcompanhamentoDocumentoDepr {
  DECLARACAO_DE_VERACIDADE = "DECLARACAO_DE_VERACIDADE",
  RELATORIO_DE_AUDITORIA = "RELATORIO_DE_AUDITORIA",
}

export const tiposAcompanhamentoDocumentoDepr = [
  {
    id: "D",
    valor: TipoAcompanhamentoDocumentoDepr.DECLARACAO_DE_VERACIDADE,
    descricao: "Declaração de veracidade",
  },
  {
    id: "R",
    valor: TipoAcompanhamentoDocumentoDepr.RELATORIO_DE_AUDITORIA,
    descricao: "Relatório de auditoria",
  },
];

export enum PeriodoAcompanhamentoDocumentoDepr {
  SEMESTRE_1 = "SEMESTRE_1",
  SEMESTRE_2 = "SEMESTRE_2",
}

export const periodosAcompanhamentoDocumentoDepr = [
  {
    id: "1",
    valor: PeriodoAcompanhamentoDocumentoDepr.SEMESTRE_1,
    descricao: "Semestre-1",
  },
  {
    id: "2",
    valor: PeriodoAcompanhamentoDocumentoDepr.SEMESTRE_2,
    descricao: "Semestre-2",
  },
];

export enum PeriodoAcompanhamentoDocumentoDepr {
  EM_PREENCHIMENTO = 1,
  EM_VALIDACAO = 2,
  VALIDADO = 3,
  REJEITADO = 4
}

export const estadosAcompanhamentoDocumentoDepr = [
  {
    valor: PeriodoAcompanhamentoDocumentoDepr.EM_PREENCHIMENTO,
    descricao: "Em preenchimento",
  },
  {
    valor: PeriodoAcompanhamentoDocumentoDepr.EM_VALIDACAO,
    descricao: "Em validação",
  },
  {
    valor: PeriodoAcompanhamentoDocumentoDepr.VALIDADO,
    descricao: "Validado",
  },
  {
    valor: PeriodoAcompanhamentoDocumentoDepr.REJEITADO,
    descricao: "Rejeitado",
  },
];
